<template>
  <div class="empsheet">
    <div class="empsheet__container">
      <div class="empsheet__tabs">
        <div
          class="empsheet__tab"
          @click="currentView = 'Boleta'"
          :class="{ 'tab-selected': currentView == 'Boleta' }"
        >
          Boleta de Pago
        </div>

        <div
          class="empsheet__tab"
          @click="currentView = 'Quinta'"
          :class="{ 'tab-selected': currentView == 'Quinta' }"
        >
          Quinta
        </div>

        <div
          class="empsheet__tab"
          @click="currentView = 'Afp'"
          :class="{ 'tab-selected': currentView == 'Afp' }"
        >
          AFP
        </div>

        <div
          class="empsheet__tab"
          @click="currentView = 'Grati'"
          :class="{ 'tab-selected': currentView == 'Grati' }"
        >
          Gratif.
        </div>
      </div>

      <div class="empsheet__views">
        <div class="empsheet__boleta" v-show="currentView == 'Boleta'">
          <!-- <div class="no-print">
            <md-field>
                    <label>Seguro de Vida Ley</label>
                    <span class="md-prefix">S/</span>
                    <md-input
                      v-model="lifeSecureLaw"
                    ></md-input>
                  </md-field>
          </div> -->
          <md-button
            class="md-dense md-raised md-primary boleta__button-print"
            @click="print"
          >
            <img :src="require('@/assets/img/printer.svg')" class="icon-button" />
            Imprimir Boleta
          </md-button>
          <div class="boleta">
            <div class="boleta__header-business">
              <p class="business__name">{{ businessComp.name }}</p>
              <p class="business__ruc">RUC: {{ businessComp.ruc }}</p>
              <p class="business__address">{{ businessComp.address }}</p>
              <h4>Boleta de Pago</h4>
              <p class="boleta__date">
                de 1 al {{ daysInMonth.days }} {{ daysInMonth.month | listaMesNumber }}
                {{ daysInMonth.year }}
              </p>
            </div>
            <div class="boleta__header-employee">
              <div class="employee__col-1">
                <div class="employee__row">
                  <div class="employee__labels">
                    <p>Nombre:</p>
                  </div>
                  <div class="employee__values">
                    <p>{{ employeeData.fullName }}</p>
                  </div>
                </div>
                <div class="employee__row">
                  <div class="employee__labels">
                    <p>Cargo:</p>
                  </div>
                  <div class="employee__values">
                    <p class="employee__occ">
                      {{
                        employeeData.professionalPosition
                          ? employeeData.professionalPosition
                          : "-"
                      }}
                    </p>
                  </div>
                </div>
                <div class="employee__row">
                  <div class="employee__labels">
                    <p>DNI/CE:</p>
                  </div>
                  <div class="employee__values">
                    <p>{{ employeeData.documentNumber }}</p>
                  </div>
                </div>
              </div>
              <div class="employee__col-2">
                <div class="employee__row">
                  <div class="employee__labels">
                    <p>F. Ingreso:</p>
                  </div>
                  <div class="employee__values">
                    <p>
                      {{ new Date(employeeData.admittedAt).toLocaleDateString() }}
                    </p>
                  </div>
                </div>
                <div class="employee__row">
                  <div class="employee__labels">
                    <p>S. de Pensión:</p>
                  </div>
                  <div class="employee__values">
                    <p class="text-wrap-line">
                      {{ employeeData.pensionSystemLabel }}
                    </p>
                  </div>
                </div>
                <div class="employee__row" v-if="afpComp.onp == '0.00'">
                  <div class="employee__labels">
                    <p>CUSPP:</p>
                  </div>
                  <div class="employee__values">
                    <p>{{ employeeData.cuspCode }}</p>
                  </div>
                </div>
              </div>
            </div>
            <div class="boleta__remu-desc">
              <div class="boleta__remuneracion">
                <div class="boleta__remuneracion-header">
                  <div class="remuneracion_label">REMUNERACIONES</div>
                  <div class="remuneracion_value">IMPORTE</div>
                </div>
                <div class="boleta__remuneracion-body">
                  <div class="remuneracion_label">
                    <div v-if="boleta.salaryByMonth">SUELDO BÁSICO</div>
                    <div v-if="!!boleta.familyAssignment">ASIGNACIÓN FAMILIAR</div>
                    <div v-if="employeeData.isRIA || !!boleta.gratification">
                      GRATIFICACIÓN ORDINARIA
                      <span v-if="employeeData.isRIA">- RIA</span>
                    </div>
                    <div v-if="employeeData.isRIA || !!boleta.extraGratifications">
                      BONIF. EXTRAORDINARIA
                      <span v-if="employeeData.isRIA">- RIA</span>
                    </div>
                    <div v-if="boleta.ctsRIA && employeeData.isRIA">CTS - RIA</div>
                    <div v-if="!!boleta.vacationSalary">VACACIONES</div>
                    <div v-if="!!boleta.vacationsVariable">VACACIONES VARIABLES</div>
                    <!-- <div v-if="!!boleta.subsidizedSalary">DESCANSO SUBSIDIADO</div> -->
                    <!-- <div v-if="!!boleta.bonuses">BONIFICACIONES</div>
                    <div v-if="!!(boleta.commissions + boleta.extraHours)">COMISIONES</div> -->
                    <div v-for="conc in concepts" :key="`concept-${conc.code}`">
                      {{ conc.description ? conc.description : conc.name }}
                    </div>
                  </div>
                  <div class="remuneracion_value">
                    <div v-if="boleta.newSalaryByMonth">{{ boleta.newSalaryByMonth | currency }}</div>
                    <!-- <div
                      v-if="!!(boleta.commissions + boleta.extraHours)"
                    >{{(boleta.commissions + boleta.extraHours) | currency}}</div> -->
                    <div v-if="!!boleta.familyAssignment">
                      {{ boleta.familyAssignment | currency }}
                    </div>
                    <div v-if="employeeData.isRIA || !!boleta.gratification">
                      {{ boleta.gratification | currency }}
                    </div>
                    <div v-if="employeeData.isRIA || boleta.extraGratifications">
                      {{ boleta.extraGratifications | currency }}
                    </div>
                    <div v-if="boleta.ctsRIA && employeeData.isRIA">
                      {{ boleta.ctsRIA | currency }}
                    </div>
                    <!-- <div v-if="!!boleta.bonuses">{{boleta.bonuses | currency}}</div> -->
                    <div v-if="!!boleta.vacationSalary">
                      {{ boleta.vacationSalary | currency }}
                    </div>
                    <div v-if="!!boleta.vacationsVariable">
                      {{ boleta.vacationsVariable | currency }}
                    </div>
                    <!-- <div v-if="!!boleta.subsidizedSalary">
                      {{ boleta.subsidizedSalary | currency }}
                    </div> -->
                    <div v-for="conc in concepts" :key="`concept-value-${conc.code}`">
                      {{ conc.value | currency }}
                    </div>
                  </div>
                </div>
                <div class="boleta__remuneracion-footer">
                  <div class="remuneracion_label">TOTAL REMUNERACIONES</div>
                  <div class="remuneracion_value">
                    {{ boleta.totalGrossRemuneration | currency }}
                  </div>
                </div>
              </div>
              <div class="boleta__descuentos">
                <div class="boleta__descuentos-header">
                  <div class="descuentos_label">DESCUENTOS</div>
                  <div class="descuentos_value">IMPORTE</div>
                </div>
                <div class="boleta__descuentos-body">
                  <div class="descuentos_label">
                    <div v-if="boleta.pensionCalc && boleta.pensionCalc.onp">ONP</div>
                    <div v-if="boleta.resume5ta && boleta.resume5ta.has5ta">
                      IMPUESTO A LA RENTA 5TA
                    </div>
                    <div
                      v-if="
                        boleta.pensionCalc && boleta.pensionCalc.mandatoryContribution
                      "
                    >
                      AFP FONDO DE PENSIÔN APORTE OBLIG.
                    </div>
                    <div v-if="boleta.pensionCalc && boleta.pensionCalc.secure">
                      AFP SEGURO DE VIDA, INVALIDEZ Y SOBREVIVENCIA
                    </div>
                    <div v-if="boleta.pensionCalc && boleta.pensionCalc.commission">
                      AFP COMISIÓN POR SERVICIOS APORTE OBLIG
                    </div>
                    <!-- <div>DESCUENTOS / EPS</div> -->
                    <div
                      class="toUpperCase"
                      v-for="disc in deductions"
                      :key="`deduction-name-${disc.description}`"
                    >
                      {{ disc.description }}
                    </div>
                  </div>
                  <div class="descuentos_value">
                    <div v-if="boleta.pensionCalc && boleta.pensionCalc.onp">
                      {{ boleta.pensionCalc.onp | currency }}
                    </div>
                    <div v-if="boleta.resume5ta && boleta.resume5ta.has5ta">
                      {{ boleta.resume5taMonth | currency }}
                    </div>
                    <div
                      v-if="
                        boleta.pensionCalc && boleta.pensionCalc.mandatoryContribution
                      "
                    >
                      {{ boleta.pensionCalc.mandatoryContribution | currency }}
                    </div>
                    <div v-if="boleta.pensionCalc && boleta.pensionCalc.secure">
                      {{ boleta.pensionCalc.secure | currency }}
                    </div>
                    <div v-if="boleta.pensionCalc && boleta.pensionCalc.commission">
                      {{ boleta.pensionCalc.commission | currency }}
                    </div>
                    <div
                      v-for="disc in deductions"
                      :key="`deduction-value-${disc.description}`"
                    >
                      {{ disc.value | currency }}
                    </div>
                    <!-- <div v-if="!!boleta.deductions">{{boleta.deductions | currency}}</div> -->
                  </div>
                </div>
                <div class="boleta__descuentos-footer">
                  <div class="descuentos_label">TOTAL DESCUENTOS</div>
                  <div class="descuentos_value">
                    {{ boleta.totalDiscounts | currency }}
                  </div>
                </div>
              </div>
            </div>
            <div class="boleta__sueldos-aux">
              <div class="sueldos-aux-basico">
                <div class="sueldo-aux__label">
                  <div>SUELDO BÁSICO</div>
                </div>
                <div class="sueldo-aux__value">
                  <div>{{ boleta.grossSalary | currency }}</div>
                </div>
              </div>
              <div class="sueldos-aux-neto">
                <div class="sueldo-aux__label">
                  <div>NETO</div>
                  <div>ADELANTO</div>
                  <div class="imp">A PAGAR</div>
                </div>
                <div class="sueldo-aux__value">
                  <div>{{ boleta.netSalary | currency }}</div>
                  <div>{{ boleta.advancePayment | currency }}</div>
                  <div class="imp">
                    {{ boleta.totalToPay | currency }}
                  </div>
                </div>
              </div>
            </div>
            <div class="boleta__extra">
              <div class="extra-info">
                <div class="extra-info__top">
                  <div class="extra-time">
                    <div class="extra-time__label">
                      <div>N. DIAS EFECTIVOS</div>
                      <div>N. HRS ORDINARIAS</div>
                      <div>HRS CONTRATO</div>
                      <div>DIAS NO TRABAJ. NO SUBS.</div>
                    </div>
                    <div class="extra-time__value">
                      <div v-if="boleta.dayReport">{{ boleta.dayReport.assistance }}</div>
                      <div v-if="boleta.dayReport">{{ boleta.dayReport.totalHours }}</div>
                      <div v-if="boleta.employee">
                        {{ boleta.employee.contractualHours }}
                      </div>
                      <div v-if="boleta.dayReport">
                        {{ boleta.dayReport._DAYSNOTWORKEDANDNOTSUBSIDIZED }}
                      </div>
                    </div>
                  </div>
                  <div class="extra-aporte">
                    <div class="extra-aporte__header">APORTACIONES</div>
                    <div class="extra-aporte__body">
                      <div class="extra-aporte__label">
                        <div> {{ healthRegime[boleta.tregisterMonth.healthRegime] }} </div>
                        <div v-if="boleta.eps">EPS</div>
                        <div v-if="boleta.sctr">SCTR</div>
                        <div v-for="contribution in boleta.employerContributions" :key="contribution.conceptCode">
                          {{ contribution.description }}
                        </div>

                      </div>
                      <div class="extra-aporte__value">
                        <div>{{ boleta.esSalud | currency }}</div>
                        <div v-if="boleta.eps">{{ boleta.eps | currency }}</div>
                        <div v-if="boleta.sctr">{{ boleta.sctr | currency }}</div>
                        <div v-for="contribution in boleta.employerContributions" :key="contribution.conceptCode">
                          {{ contribution.value | currency }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="extra-info__mid">
                  <div class="extra__vacaciones">
                    <div class="vacaciones__header">VACACIONES</div>
                    <div class="vacaciones__body">
                      <div class="vacaciones__start">
                        <div class="start-header">Dias</div>
                      </div>
                      <div class="vacaciones__end">
                        <div class="end-header" v-if="boleta.dayReport">
                          {{ boleta.dayReport.vacation || 0 }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="extra__prestamo">
                    <div class="prestamo__header">PRESTAMO</div>
                    <div class="prestamo__body">{{ boleta.loans | currency }}</div>
                  </div>
                </div>
                <p class="hide-document" v-if="employeeData">
                  {{ documentType[employeeData.documentType] }}:{{
                    employeeData.documentNumber.trim()
                  }}
                </p>
                <div class="extra-info__bot">
                  <div class="info-bot__label">
                    <div>FORMA DE PAGO</div>
                    <div>BANCO</div>
                    <div>N. DE CUENTA</div>
                  </div>
                  <div class="info-bot__values">
                    <div>{{ boleta.paymentType }}</div>
                    <div>{{ boleta.bankName }}</div>
                    <div>{{ boleta.bankAccount }}</div>
                  </div>
                </div>
              </div>
              <div class="extra-sign">
                <div class="extra-sign__empleador">
                  <div class="sign-box"></div>
                  <div class="sign-info">
                    <p>{{ businessComp.legalRepresentative }}</p>
                    <p>{{ businessComp.legalRepresentativePosition }}</p>
                  </div>
                </div>
                <div class="extra-sign__receptor">
                  <div class="sign-box"></div>
                  <div class="sign-info">
                    <p>{{ employeeData.fullName }}</p>
                    <p>Recibí conforme</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="empsheet__quinta" v-show="currentView == 'Quinta'">
          <md-card class="md-layout-item md-size-100 md-small-size-100" v-if="quinta">
            <md-card-header>
              <div class="md-title">Cálculo de Impuesto a la Renta 5TA Anual</div>
            </md-card-header>

            <md-card-content>
              <div class="md-layout md-gutter">
                <div class="md-layout-item md-small-size-100">
                  <md-field>
                    <label>Remuneración total de Empresa anterior</label>
                    <span class="md-prefix">S/</span>
                    <md-input
                      :value="quinta.totalPrevRemunerations | decimales"
                      disabled
                    ></md-input>
                  </md-field>
                </div>
                <div class="md-layout-item md-small-size-100">
                  <md-field>
                    <label>Total de impuesto a la renta pagado anterior</label>
                    <span class="md-prefix">S/</span>
                    <md-input
                      :value="quinta.totalPrevRetentions | decimales"
                      disabled
                    ></md-input>
                  </md-field>
                </div>
              </div>
              <div class="md-layout md-gutter">
                <div class="md-layout-item md-small-size-100">
                  <md-field>
                    <label>Remuneración total de otra Empresa</label>
                    <span class="md-prefix">S/</span>
                    <md-input
                      :value="quinta.totalOtherRemunerations | decimales"
                      disabled
                    ></md-input>
                  </md-field>
                </div>
                <div class="md-layout-item md-small-size-100">
                  <md-field>
                    <label>Renta de otra Empresa</label>
                    <span class="md-prefix">S/</span>
                    <md-input
                      :value="quinta.totalOtherRetentions | decimales"
                      disabled
                    ></md-input>
                  </md-field>
                </div>
              </div>
              <div class="md-layout md-gutter">
                <div class="md-layout-item md-small-size-100">
                  <md-field>
                    <label>Sueldo Anual</label>
                    <span class="md-prefix">S/</span>
                    <md-input
                      :value="quinta.annualGrossSalary | decimales"
                      disabled
                    ></md-input>
                  </md-field>
                </div>
                <div class="md-layout-item md-small-size-100">
                  <md-field>
                    <label>Asignación Familiar Anual</label>
                    <span class="md-prefix">S/</span>
                    <md-input
                      :value="quinta.annualFamilyAssignment | decimales"
                      disabled
                    ></md-input>
                  </md-field>
                </div>
                <div class="md-layout-item md-small-size-100">
                  <md-field>
                    <label>Horas Extras</label>
                    <span class="md-prefix">S/</span>
                    <md-input :value="quinta.extraHour | decimales" disabled></md-input>
                  </md-field>
                </div>
              </div>

              <div class="md-layout md-gutter">
                <div class="md-layout-item md-small-size-100">
                  <md-field>
                    <label>Gratificación Julio</label>
                    <span class="md-prefix">S/</span>
                    <md-input :value="grati.july | decimales" disabled></md-input>
                  </md-field>
                </div>
                <div class="md-layout-item md-small-size-100">
                  <md-field>
                    <label>Bono Gratificación Julio</label>
                    <span class="md-prefix">S/</span>
                    <md-input :value="grati.julyBonus | decimales" disabled></md-input>
                  </md-field>
                </div>
                <div class="md-layout-item md-small-size-100">
                  <md-field>
                    <label>Comisiones</label>
                    <span class="md-prefix">S/</span>
                    <md-input :value="quinta.commissions | decimales" disabled></md-input>
                  </md-field>
                </div>
              </div>

              <div class="md-layout md-gutter">
                <div class="md-layout-item md-small-size-100">
                  <md-field>
                    <label>Gratificación Diciembre</label>
                    <span class="md-prefix">S/</span>
                    <md-input :value="grati.december | decimales" disabled></md-input>
                  </md-field>
                </div>
                <div class="md-layout-item md-small-size-100">
                  <md-field>
                    <label>Bono Gratificación Diciembre</label>
                    <span class="md-prefix">S/</span>
                    <md-input
                      :value="grati.decemberBonus | decimales"
                      disabled
                    ></md-input>
                  </md-field>
                </div>
                <div class="md-layout-item md-small-size-100">
                  <md-field>
                    <label>Bonos</label>
                    <span class="md-prefix">S/</span>
                    <md-input :value="quinta.bonuses | decimales" disabled></md-input>
                  </md-field>
                </div>
                <div class="md-layout-item md-size-33 md-small-size-100">
                  <md-field>
                    <label>Vacaciones</label>
                    <span class="md-prefix">S/</span>
                    <md-input
                      :value="quinta.sumatoryVacationSalary | decimales"
                      disabled
                    ></md-input>
                  </md-field>
                </div>
                <div class="md-layout-item md-size-33 md-small-size-100">
                  <md-field>
                    <label>Otros</label>
                    <span class="md-prefix">S/</span>
                    <md-input
                      :value="quinta.othersPayments5ta | decimales"
                      disabled
                    ></md-input>
                  </md-field>
                </div>
              </div>

              <div class="md-layout md-gutter">
                <div class="md-layout-item md-small-size-100">
                  <md-field>
                    <label>Remuneración Bruta Anual</label>
                    <span class="md-prefix">S/</span>
                    <md-input
                      :value="quinta.annualGrossRemuneration | decimales"
                      disabled
                    ></md-input>
                  </md-field>
                </div>
                <div class="md-layout-item md-small-size-100">
                  <md-field>
                    <label>Remuneración Neta Anual</label>
                    <span class="md-prefix">S/</span>
                    <md-input
                      :value="quinta.annualNetRemuneration | decimales"
                      disabled
                    ></md-input>
                  </md-field>
                </div>
                <div class="md-layout-item md-small-size-100">
                  <md-field>
                    <label>Entra a 5TA</label>
                    <md-input :value="quinta.has5ta ? 'Sí' : 'No'" disabled></md-input>
                  </md-field>
                </div>
              </div>

              <div class="md-layout md-gutter" v-if="quinta.stretchs">
                <div class="md-layout-item md-small-size-100">
                  <md-field>
                    <label>Desc. 8%</label>
                    <span class="md-prefix">S/</span>
                    <md-input
                      :value="quinta.stretchs.stretch1 | decimales"
                      disabled
                    ></md-input>
                  </md-field>
                </div>
                <div class="md-layout-item md-small-size-100">
                  <md-field>
                    <label>Desc. 14%</label>
                    <span class="md-prefix">S/</span>
                    <md-input
                      :value="quinta.stretchs.stretch2 | decimales"
                      disabled
                    ></md-input>
                  </md-field>
                </div>
                <div class="md-layout-item md-small-size-100">
                  <md-field>
                    <label>Desc. 17%</label>
                    <span class="md-prefix">S/</span>
                    <md-input
                      :value="quinta.stretchs.stretch3 | decimales"
                      disabled
                    ></md-input>
                  </md-field>
                </div>
              </div>

              <div class="md-layout md-gutter" v-if="quinta.stretchs">
                <div class="md-layout-item md-small-size-100">
                  <md-field>
                    <label>Desc. 20%</label>
                    <span class="md-prefix">S/</span>
                    <md-input
                      :value="quinta.stretchs.stretch4 | decimales"
                      disabled
                    ></md-input>
                  </md-field>
                </div>
                <div class="md-layout-item md-small-size-100">
                  <md-field>
                    <label>Desc. 30%</label>
                    <span class="md-prefix">S/</span>
                    <md-input
                      :value="quinta.stretchs.stretch5 | decimales"
                      disabled
                    ></md-input>
                  </md-field>
                </div>
                <div class="md-layout-item md-small-size-100">
                  <md-field class="field-important">
                    <label>Desc. 5TA Anual</label>
                    <span class="md-prefix">S/</span>
                    <md-input :value="quinta.annual5ta | decimales" disabled></md-input>
                  </md-field>
                </div>
              </div>
            </md-card-content>
            <md-card-content>
              <md-table :value="quinta.months">
                <md-table-toolbar>
                  <h1 class="md-title">Renta Mensual</h1>
                </md-table-toolbar>
                <md-table-row>
                  <md-table-head
                    v-for="(item, $index) in quinta.months"
                    :key="`tabla-quinta-head-mensual-${$index}`"
                    >{{ $index | listaMesNumber }}</md-table-head
                  >
                </md-table-row>
                <md-table-row>
                  <md-table-cell
                    v-for="(item, $index) in quinta.months"
                    :key="`tabla-quinta-mensual-cell-${$index}`"
                  >
                    <md-field md-inline>
                      <!-- <label>{{$index}}</label> -->
                      <span class="md-prefix">S/</span>
                      <md-input
                        class="input-quinta-tabla-cell"
                        :value="quinta.months[$index] + (quinta.monthsExtraordinary[$index] || 0) | decimales"
                      ></md-input>
                    </md-field>
                    <p style="color: darkred;" v-if="quinta.monthsExtraordinary[$index]">
                      incluye S/ {{ quinta.monthsExtraordinary[$index] | decimales }} (Renta Extraor.)
                    </p>
                  </md-table-cell>
                </md-table-row>
              </md-table>
            </md-card-content>
          </md-card>
        </div>

        <div class="empsheet__afp" v-show="currentView == 'Afp'">
          <md-card class="md-layout-item md-size-100 md-small-size-100">
            <md-card-header>
              <div class="md-title">Variables para el Cálculo de Pensiones</div>
            </md-card-header>

            <md-card-content>
              <div class="md-layout md-gutter">
                <div class="md-layout-item md-small-size-100">
                  <md-field>
                    <label>Remuneración Total</label>
                    <span class="md-prefix">S/</span>
                    <md-input
                      :value="afpComp.totalRemuneration | decimales"
                      disabled
                    ></md-input>
                  </md-field>
                </div>
                <div class="md-layout-item md-small-size-100">
                  <md-field>
                    <label>Remuneración Máxima Asegurable</label>
                    <span class="md-prefix">S/</span>
                    <md-input
                      :value="afpComp.maxSecureRemuneration | decimales"
                      disabled
                    ></md-input>
                  </md-field>
                </div>
              </div>

              <div class="md-layout md-gutter">
                <div class="md-layout-item md-small-size-100">
                  <md-field>
                    <label>Aporte Obligatorio</label>
                    <span class="md-prefix">%</span>
                    <md-input
                      :value="afpComp.mandatoryContributionPercentage | decimales"
                      disabled
                    ></md-input>
                  </md-field>
                </div>
                <div class="md-layout-item md-small-size-100">
                  <md-field>
                    <label>Prima de Seguro</label>
                    <span class="md-prefix">%</span>
                    <md-input
                      :value="afpComp.securePrimePercentage | decimales"
                      disabled
                    ></md-input>
                  </md-field>
                </div>
                <div class="md-layout-item md-small-size-100">
                  <md-field>
                    <label>Comisión</label>
                    <span class="md-prefix">%</span>
                    <md-input
                      :value="afpComp.commisionPercentage | decimales"
                      disabled
                    ></md-input>
                  </md-field>
                </div>
              </div>
            </md-card-content>
          </md-card>
          <md-card class="md-layout-item md-size-100 md-small-size-100">
            <md-card-header>
              <div class="md-title">Resultados del Cálculo de Pensiones</div>
            </md-card-header>

            <md-card-content>
              <div class="md-layout md-gutter">
                <div class="md-layout-item md-small-size-100">
                  <md-field>
                    <label>Aporte Obligatorio al Fondo de Pensión</label>
                    <span class="md-prefix">S/</span>
                    <md-input
                      :value="afpComp.mandatoryContribution | decimales"
                      disabled
                    ></md-input>
                  </md-field>
                </div>
                <div class="md-layout-item md-small-size-100">
                  <md-field>
                    <label>Seguro de Vida, Invalidez y Sobrevivencia</label>
                    <span class="md-prefix">S/</span>
                    <md-input :value="afpComp.secure | decimales" disabled></md-input>
                  </md-field>
                </div>
                <div class="md-layout-item md-small-size-100">
                  <md-field>
                    <label>Comisión por Servicios</label>
                    <span class="md-prefix">S/</span>
                    <md-input :value="afpComp.commission | decimales" disabled></md-input>
                  </md-field>
                </div>
              </div>

              <div class="md-layout md-gutter">
                <div class="md-layout-item md-small-size-100">
                  <md-field>
                    <label>ONP</label>
                    <span class="md-prefix">S/</span>
                    <md-input :value="afpComp.onp | decimales" disabled></md-input>
                  </md-field>
                </div>
                <div class="md-layout-item md-small-size-100">
                  <md-field class="field-important">
                    <label>Total Pensiones</label>
                    <span class="md-prefix">S/</span>
                    <md-input
                      :value="afpComp.totalPension | decimales"
                      disabled
                    ></md-input>
                  </md-field>
                </div>
              </div>
            </md-card-content>
          </md-card>
        </div>
        <div class="empsheet__cts" v-show="currentView == 'Grati'">
          <md-card class="md-layout-item md-size-100 md-small-size-100 my-20">
            <md-card-header>
              <div class="md-title">Variables para el Cálculo de Gratificación</div>
            </md-card-header>

            <md-card-content>
              <div class="md-layout md-gutter">
                <div class="md-layout-item md-small-size-100">
                  <md-field>
                    <label>Fecha de Ingreso</label>
                    <!-- <span class="md-prefix">S/</span> -->
                    <md-input :value="ctsComp.startDate" disabled></md-input>
                  </md-field>
                </div>
                <div class="md-layout-item md-small-size-100">
                  <md-field>
                    <label>Sueldo</label>
                    <span class="md-prefix">S/</span>
                    <md-input :value="boleta.grossSalary | decimales" disabled></md-input>
                  </md-field>
                </div>
                <div class="md-layout-item md-small-size-100">
                  <md-field>
                    <label>Asignación Familiar</label>
                    <span class="md-prefix">S/</span>
                    <md-input
                      :value="boleta.familyAssignment | decimales"
                      disabled
                    ></md-input>
                  </md-field>
                </div>
                <div class="md-layout-item md-small-size-100">
                  <md-field>
                    <label>Promedio de Comisiones</label>
                    <span class="md-prefix">S/</span>
                    <md-input
                      :value="grati.prom6commision | decimales"
                      disabled
                    ></md-input>
                  </md-field>
                </div>
                <div class="md-layout-item md-small-size-100">
                  <md-field>
                    <label>Promedio de Bonos</label>
                    <span class="md-prefix">S/</span>
                    <md-input
                      :value="grati.prom3in6bonuses | decimales"
                      disabled
                    ></md-input>
                  </md-field>
                </div>
                <div class="md-layout-item md-small-size-100">
                  <md-field>
                    <label>Promedio de Horas Extras</label>
                    <span class="md-prefix">S/</span>
                    <md-input
                      :value="grati.prom3in6extraHours | decimales"
                      disabled
                    ></md-input>
                  </md-field>
                </div>
                <div class="md-layout-item md-small-size-100">
                  <md-field class="field-important">
                    <label>Base para la Gratificación</label>
                    <span class="md-prefix">S/</span>
                    <md-input :value="grati.baseGrat | decimales" disabled></md-input>
                  </md-field>
                </div>
              </div>
            </md-card-content>
          </md-card>

          <md-card class="md-layout-item md-size-100 md-small-size-100 my-20 z-200" v-if="$store.getters.calcActualGrati.gratification > 0">
            <md-card-header>
              <div class="md-title">Cálculo de Intereses de Gratificación</div>
            </md-card-header>

            <md-card-content>
              <div class="md-layout md-gutter">
                <div class="md-layout-item md-small-size-100">
                  <md-field style="max-width: 200px;">
                    <label>Fecha de depósito de Gratificación</label>
                    <v-date-picker v-model="depositAt" class="datepick" :formats="formats" popover-visibility="focus">
                      <!-- :min-date="minDate" -->
                      <!-- OJO -->
                      <md-input slot-scope="{ inputValue }" style="text-align: left !important" :value="inputValue"
                        readonly></md-input>
                    </v-date-picker>
                  </md-field>
                </div>
                <div class="md-layout-item md-small-size-100">
                  <md-button @click="getFactors" class="md-raised md-primary">Calcular interés</md-button>
                </div>
                <div class="md-layout-item md-small-size-100" v-if="diffFactor > 0">
                  <md-field>
                    <label for="">Factor de interés</label>
                    <md-input v-model="diffFactor"></md-input>
                  </md-field>
                </div>
                <div class="md-layout-item md-small-size-100">
                  <md-field>
                    <label for="">Interés de gratificación</label>
                    <md-input v-model="interestGrati.gratification"></md-input>
                  </md-field>
                </div>
                <div class="md-layout-item md-small-size-100">
                  <md-field>
                    <label for="">Interes de bono</label>
                    <md-input v-model="interestGrati.bonus"></md-input>
                  </md-field>
                </div>
                <div class="md-layout-item md-small-size-100">
                  <md-field>
                    <label for="">Pago total</label>
                    <md-input v-model="pagoGratiTotal"></md-input>
                  </md-field>
                </div>
                <div class="md-layout-item md-small-size-100">
                  <md-button @click="saveGratiPayment" class="md-raised md-primary">Guardar Pagos</md-button>
                </div>
              </div>
            </md-card-content>
          </md-card>

          <md-card class="md-layout-item md-size-100 md-small-size-100 my-20">
            <md-card-header>
              <div class="md-title">Provisiones de Gratificación</div>
            </md-card-header>
            <md-card-content>
              <div
                class="md-layout md-gutter"
                v-for="prevGrati in grati.prevGratifications"
                :key="`${prevGrati.type}-${prevGrati.tag}`"
              >
                <div class="md-layout-item md-small-size-100">
                  <md-field>
                    <label
                      >{{ monthLabel[`${prevGrati.tag.split("-")[1]}`] }} (Monto)</label
                    >
                    <span class="md-prefix">S/</span>
                    <md-input :value="prevGrati.value | decimales" disabled></md-input>
                  </md-field>
                </div>
              </div>
              <div class="md-layout md-gutter">
                <div class="md-layout-item md-small-size-100">
                  <md-field class="field-important">
                    <label>Gratificación Acumulada</label>
                    <span class="md-prefix">S/</span>
                    <md-input
                      :value="grati.sumGratifications | decimales"
                      disabled
                    ></md-input>
                  </md-field>
                </div>
                <div class="md-layout-item md-small-size-100">
                  <md-field>
                    <label>Bono Extraordinario - Porcentaje</label>
                    <md-input :value="grati.rate | decimales" disabled></md-input>
                    <span class="md-sufix">%</span>
                  </md-field>
                </div>
                <div class="md-layout-item md-small-size-100">
                  <md-field class="field-important">
                    <label>Bono Extraordinario Acumulado- Monto</label>
                    <span class="md-prefix">S/</span>
                    <md-input :value="grati.sumBonuses | decimales" disabled></md-input>
                  </md-field>
                </div>
              </div>
            </md-card-content>
          </md-card>
          <md-card class="md-layout-item md-size-100 md-small-size-100 my-20">
            <md-card-header>
              <div class="md-title">Gratificación del Mes</div>
            </md-card-header>
            <md-card-content>
              <div class="md-layout md-gutter">
                <div class="md-layout-item md-small-size-100">
                  <md-field>
                    <label>Monto del mes actual</label>
                    <span class="md-prefix">S/</span>
                    <md-input :value="grati.gratiMonth | decimales" disabled></md-input>
                  </md-field>
                </div>
                <div class="md-layout-item md-small-size-100">
                  <md-field>
                    <label>Bono del mes actual</label>
                    <span class="md-prefix">S/</span>
                    <md-input
                      :value="grati.gratiMonthBonus | decimales"
                      disabled
                    ></md-input>
                  </md-field>
                </div>
              </div>
              <div class="md-layout md-gutter">
                <div class="md-layout-item md-small-size-100">
                  <md-field class="field-important">
                    <label>Provisión total del mes actual</label>
                    <span class="md-prefix">S/</span>
                    <md-input :value="grati.totalPrev | decimales" disabled></md-input>
                  </md-field>
                </div>
              </div>
            </md-card-content>
          </md-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import createNumberMask from 'text-mask-addons/dist/createNumberMask';
import { set } from 'core-js/core/dict';
import dayjs from 'dayjs'
export default {
  props: {
    value: Object,
  },
  name: "EmpSheet",
  data() {
    return {
      currentView: "Boleta",
      today: new Date(),
      monthLabel: {
        "01": "Enero",
        "02": "Febrero",
        "03": "Marzo",
        "04": "Abril",
        "05": "Mayo",
        "06": "Junio",
        "07": "Julio",
        "08": "Agosto",
        "09": "Setiembre",
        10: "Octubre",
        11: "Noviembre",
        12: "Diciembre",
      },
      documentType: {
        "01": "DNI",
        "04": "CE",
        "07": "PPT",
        23: "PTP",
      },
      healthRegime: {
        "00": "EsSalud",
        "01": "EsSalud",
        "05": "EsSalud",
        "20": "EsSalud",
        "21": "SIS",
        undefined: undefined
      },
      showGratiPayment:false,
      expiredFactor: 0,
      paymentFactor: 0,
      depositAt: dayjs().toDate(),
      formats: {
        input: "D MMM YYYY",
      },
      realGratiId: null,
      interest: 0,
      interestBonus: 0,
      lifeSecureLaw: 0
    };
  },
  computed: {
    afpComp() {
      if (!this.$store.getters.calcAfp) return {};
      return {
        commisionPercentage: Number(
          this.$store.getters.calcAfp.commisionPercentage * 100
        ).toFixed(2),
        commission: Number(this.$store.getters.calcAfp.commission).toFixed(2),
        mandatoryContribution: Number(
          this.$store.getters.calcAfp.mandatoryContribution
        ).toFixed(2),
        mandatoryContributionPercentage: Number(
          this.$store.getters.calcAfp.mandatoryContributionPercentage * 100
        ).toFixed(2),
        maxSecureRemuneration: Number(
          this.$store.getters.calcAfp.maxSecureRemuneration
        ).toFixed(2),
        onp: Number(this.$store.getters.calcAfp.onp).toFixed(2),
        secure: Number(this.$store.getters.calcAfp.secure).toFixed(2),
        securePrimePercentage: Number(
          this.$store.getters.calcAfp.securePrimePercentage * 100
        ).toFixed(2),
        totalRemuneration: Number(this.$store.getters.calcAfp.afpOnpRemuneration).toFixed(
          2
        ),
        totalPension: Number(
          Number(this.$store.getters.calcAfp.commission) +
            Number(this.$store.getters.calcAfp.mandatoryContribution) +
            Number(this.$store.getters.calcAfp.onp) +
            Number(this.$store.getters.calcAfp.secure)
        ).toFixed(2),
      };
      // return this.$store.getters.calcAfp;
    },
    quinta() {
      if (!this.$store.getters.calcRenta) return {};
      return this.$store.getters.calcRenta;
    },
    grati() {
      if (!this.$store.getters.calcGrati) return {};
      let prevAux = [...this.$store.getters.calcGrati.prevGratifications];
      return {
        ...this.$store.getters.calcGrati,
        bonusPrev:
          (this.$store.getters.calcGrati.gratiMonth *
            this.$store.getters.calcGrati.rate) /
          100,
        totalPrev:
          this.$store.getters.calcGrati.gratiMonth +
          this.$store.getters.calcGrati.gratiMonthBonus,
        prevGratifications: prevAux.reverse(),
      };
    },
    boleta() {
      if (!this.$store.state.business.summary.month) return {};
      return this.$store.state.business.summary.month;
    },
    noWorkNoPayDays() {
      if (!this.boleta.dayReport) return 0;
      return (
        this.boleta.dayReport.absence +
        this.boleta.dayReport.licenceUnpayed +
        this.boleta.dayReport.medicalBreak +
        this.boleta.dayReport.vacation +
        this.boleta.dayReport.licencePayed
      );
    },
    businessComp() {
      if (!this.$store.state.enterprise.dataBusiness) return {};
      return this.$store.state.enterprise.dataBusiness;
    },
    daysInMonth() {
      if (!this.$route.params.date) return {};
      return {
        days: new Date(
          new Date(this.$route.params.date).getFullYear(),
          new Date(this.$route.params.date).getMonth() + 1,
          0
        ).getDate(),
        month: new Date(
          new Date(this.$route.params.date).getFullYear(),
          new Date(this.$route.params.date).getMonth() + 1,
          0
        ).getMonth(),
        year: new Date(this.$route.params.date).getFullYear(),
      };
    },
    employeeData() {
      if (!this.$store.state.business.summary.month) return "";
      console.log(this.$store.state.business.summary.month.employee);

      return this.$store.state.business.summary.month.employee;
    },
    dataVarious() {
      if (!this.$store.state.business.summary.month) return {};
      return this.$store.state.business.summary.month;
    },
    ctsComp() {
      if (!this.$store.getters.calcCts) return {};
      return {
        basicRemCts: Number(this.$store.getters.calcCts.rbcts).toFixed(2),
        actualMonth: Number(this.$store.getters.calcCts.ctsMonth).toFixed(2),
        period: this.$store.getters.calcCts.actualPeriod,
        mayOct: Number(this.$store.getters.calcCts.mayOct).toFixed(2),
        novAbr: Number(this.$store.getters.calcCts.novAbr).toFixed(2),
        daysCounted: this.$store.getters.calcCts.workedAccumDays,
        startDate: new Date(this.employeeData.admittedAt).toLocaleDateString(),
        commisionProm: Number(this.$store.getters.calcCts.promCommisions).toFixed(2),
        ctsGrat: Number(this.$store.getters.calcCts.periodGratCts).toFixed(2),
        months:
          this.$store.getters.calcCts.actualPeriod === "mayOct"
            ? this.$store.getters.calcCts.allPeriods.slice(6).map((i) => {
                return {
                  period: i.date,
                  month: Number(i.date.split("-")[1] - 1),
                  value: Number(i.value).toFixed(2),
                };
              })
            : this.$store.getters.calcCts.allPeriods.slice(0, 6).map((i) => {
                return {
                  period: i.date,
                  month: Number(i.date.split("-")[1] - 1),
                  value: Number(i.value).toFixed(2),
                };
              }),
      };
    },
    concepts() {
      if (!this.$store.getters.calcConcepts) return [];
      return this.$store.getters.calcConcepts.map((it) => {
        return {
          name: it.concept.name,
          value: it.value,
          code: it.conceptCode,
          description: it.description,
        };
      });
    },
    deductions() {
      if (!this.$store.getters.calcDeductions) return [];
      return this.$store.getters.calcDeductions.map((it) => {
        return {
          description: it.description,
          value: it.value,
        };
      });
    },
    expiredAt(){
      return this.getExpiredAt(this.$route.params.date)
    },
    diffFactor(){
      return Number(Math.abs(this.expiredFactor-this.paymentFactor).toFixed(5));
    },
    interestGrati: {
      get(){
        if(!this.$store.getters.calcActualGrati) return {
          gratification: 0,
          bonus: 0
        }
        return {
          gratification: this.interest || Number((this.$store.getters.calcActualGrati.gratification*this.diffFactor).toFixed(2)),
          bonus: this.interestBonus || Number((this.$store.getters.calcActualGrati.bonus*this.diffFactor).toFixed(2))
        }
      }
    },
    pagoGratiTotal:{
      get(){
        if(!this.$store.getters.calcActualGrati) return 0;
        return Number((this.$store.getters.calcActualGrati.gratification + this.$store.getters.calcActualGrati.bonus + this.interestGrati.gratification + this.interestGrati.bonus).toFixed(2))
      },
      set(value){
        return Number(value.toFixed(2))
      }
    }
  },
  async created() {
    console.log(this.$route.params.date, new Date(this.$route.params.date));

    await this.$store.dispatch("summaryByMonth", {
      id: this.$localStorage.get("businessID"),
      employee: this.$route.params.id,
      date: new Date(this.$route.params.date).toISOString(),
    });

    const res = await this.$store.dispatch("getEmployeeGratiReal", {id: this.$route.params.id, query:`date=${this.$route.params.date}` })
    if(!res){
      this.realGratiId = res.data.id;
      this.interest = res.data.interest,
      this.interestBonus = res.data.interestBonus
      this.pagoGratiTotal = res.data.amount || res.data.value;
    }
  },
  filters: {
    listaMes(val) {
      switch (val) {
        case "juanuary":
          return "Enero";
        case "february":
          return "Febrero";
        case "march":
          return "Marzo";
        case "april":
          return "Abril";
        case "may":
          return "Mayo";
        case "june":
          return "Junio";
        case "july":
          return "Julio";
        case "august":
          return "Agosto";
        case "september":
          return "Setiembre";
        case "octuber":
          return "Octubre";
        case "november":
          return "Noviembre";
        case "december":
          return "Diciembre";
      }
    },
    listaMesNumber(val) {
      switch (Number(val)) {
        case 0:
          return "Enero";
        case 1:
          return "Febrero";
        case 2:
          return "Marzo";
        case 3:
          return "Abril";
        case 4:
          return "Mayo";
        case 5:
          return "Junio";
        case 6:
          return "Julio";
        case 7:
          return "Agosto";
        case 8:
          return "Setiembre";
        case 9:
          return "Octubre";
        case 10:
          return "Noviembre";
        case 11:
          return "Diciembre";
      }
    },
  },
  methods: {
    print() {
      window.print();
    },
    saveCtsMonth(period) {
      let monthsToChange = this.ctsComp.months
        .filter((m) => m.period === period)
        .map((month) => {
          return {
            period: month.period,
            value: Number(month.value),
          };
        });
      this.$store.dispatch("updateCts", {
        id: this.$route.params.id,
        body: monthsToChange[0],
      });
    },
    async getFactors(){
      const today = dayjs().startOf("day")
      const depositAt = dayjs(this.depositAt).isBefore(today) ? dayjs(this.depositAt).startOf('day').toISOString() : dayjs(this.depositAt).subtract(1, 'day').startOf('day').toISOString()
      const res = await this.$store.dispatch("getInteresCTS",{
        id: this.$route.params.id,
        expiredAt: dayjs(this.expiredAt).startOf('day').toISOString(),
        depositAt: depositAt
      })
      this.expiredFactor = res.data.initFactor.nationalAccumFactor;
      this.paymentFactor = res.data.endFactor.nationalAccumFactor;
    },
    getExpiredAt(value){
      const year = dayjs(value).year()
      const expiredAt = dayjs(value).month() <= dayjs().year(year).month(8).month() ? dayjs().year(year).month(8).date(15).toDate() : dayjs().year(year).month(11).date(15).toDate();
      return expiredAt
    },
    async saveGratiPayment(){
      if(this.realGratiId){
        const res = await this.$store.dispatch('setEmployeeGratiReal', {
          id: this.$route.params.id,
          body: {
            amount: this.pagoGratiTotal,
            exchangeRate: 0,
            depositAt: new Date(this.depositAt).toISOString(),
            id: this.realGratiId,
            interest: this.interestGrati.gratification,
            interestBonus: this.interestGrati.bonus,
          }
        })
        if(res.status < 400){
          this.$toasted.success("Se han gravado los datos de pago de la gratificación")
        } else {
          this.$toasted.error("Error al querer guardar los datos")  
        }
      } else {
        this.$toasted.error("No hay gratificación creada para este periodo aún. No se puede guardar los datos")
      }
    }
  },
};
</script>

<style lang="scss" scooped>
//1-SETTINGS
//colors
$b-orange: #d8ff00;
$b-blue: #000000;
$b-emph: #97c2c9;
$b-blue-dark: #c63832;

//breakpoints
$sm: 600px;
$smd: 768px;
$md: 900px;
$lg: 1200px;
$xl: 1800px;
//variables
$p-img: "../assets/img/";

//2-TOOLS
//functions
//background-image function
@function bimg($img) {
  @return url($p-img + $img);
}
//mixins
@mixin mq($min-width) {
  @media screen and (min-width: $min-width) {
    @content;
  }
}

.flex-content {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-around;
  align-items: stretch;
}

.flex-content--table {
  display: flex;

  flex-flow: column nowrap;
  justify-content: flex-start;
  align-items: center;
  @include mq($smd) {
    flex-flow: row nowrap;
    justify-content: space-around;
    align-items: stretch;
  }
}

//7-TRUMPS
.tab-selected {
  background-color: #fff !important;
  font-weight: 700 !important;
  border: 1px solid rgba($b-emph, 0.75) !important;
  border-bottom: 1px solid white !important;
}

.empsheet {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  background-color: #eceff8;
  padding-bottom: 3rem;
  min-height: 20rem;
  margin: 0 auto;
  @include mq($md) {
    // width: 90%
  }

  &__container {
    padding: 0 1rem;
  }

  &__tabs {
    display: flex;
    flex-wrap: wrap;
    // padding: 0 1rem;
    justify-content: center;
    @include mq($md) {
      justify-content: flex-start;
    }
  }
  &__tab {
    padding: 0.5rem 1rem 0.5rem 0.5rem;
    background-color: #e6e6e6;
    color: #000;
    border-top-left-radius: 6px;
    border-top-right-radius: 6px;
    margin-right: 3px;
    margin-top: 0.5rem;
    @include mq($md) {
      cursor: pointer;
    }
  }

  &__views {
    // position: relative;
    padding: 1rem 1rem 3rem 1rem;
    background-color: #fff;
    // height: 100%;
    max-width: 60rem;
    @include mq($sm) {
      padding: 1rem 3rem 3rem 3rem;
    }
    @include mq($md) {
      border-radius: 6px;
    }
  }

  &__boleta,
  &__quinta,
  &__afp,
  &__cts {
    position: relative;
    display: flex;
    flex-wrap: wrap;
    flex-direction: column;
    align-items: center;
    min-height: 21rem;

    @include mq($md) {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      justify-content: space-between;
    }
  }
}
.table-remuneraciones {
  .md-table-head {
    background-color: $b-blue;
    &-label {
      color: #ffffff;
    }
  }
}
.table-descuentos {
  .md-table-head {
    background-color: #c74444;
    &-label {
      color: #ffffff;
    }
  }
}
.table-row-last {
  align-self: flex-end;
  &--rem {
    background-color: #879bec;
  }
  &--des {
    background-color: #f49f9f;
  }
}
.cell-content {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-around;
  align-items: center;
  border: thin solid #cdcdcd;
  .title-content {
    padding: 1rem;
    height: 100%;
    box-sizing: border-box;
    width: 70%;
    text-align: start;
    text-align: start;
    display: flex;
    flex-flow: row nowrap;
    justify-content: flex-start;
    align-items: center;
    background-color: #cdcdcd;
  }
  .data-content {
    display: flex;
    flex-flow: row nowrap;
    justify-content: flex-start;
    align-items: center;
    box-sizing: border-box;
    width: 30%;
    height: 100%;
    padding: 1rem;
    text-align: start;
  }
  &--column {
    flex-flow: column nowrap !important;
    justify-content: flex-start !important;
    align-items: stretch !important;
  }
  &-row {
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-around;
    .title-content {
      box-sizing: border-box;
      width: 70%;
      padding: 0 1rem;
      text-align: start;
      &--bold {
        font-weight: bold;
      }
    }
    .data-content {
      box-sizing: border-box;
      width: 30%;
      padding: 0 1rem;
      text-align: start;
    }
    &--border {
      border: thin solid #5c5c5c;
      background-color: #cdcdcd;
    }
  }
}
.field-important {
  label {
    font-weight: bold !important;
    color: $b-blue !important;
  }
  input[type="text"]:disabled {
    color: $b-orange !important;
    font-weight: bold !important;
    -webkit-text-fill-color: $b-orange !important;
  }
}
.cell-quinta-mensual {
  white-space: nowrap;
}
.input-quinta-tabla-cell {
  width: 100px !important;
}
.boleta {
  width: 100%;
  &__header-business {
    padding: 1rem 0;
    .business__name,
    .business__ruc,
    h4,
    .boleta__date {
      font-weight: bold;
    }
    .boleta__date,
    h4 {
      text-align: center;
    }
    h4 {
      margin-top: 1rem;
    }
  }
  &__header-employee {
    padding: 1rem 0;
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;
    align-items: flex-start;
    .employee__col-1,
    .employee__col-2 {
      flex: 0 0 50%;
      // height: 110px;
      // display: flex;
      // flex-flow: row nowrap;
      // justify-content: flex-start;
      // align-items: flex-start;
      border: thin solid #000000;
      .employee__row {
        display: flex;
        justify-content: flex-start;
      }
      .employee__labels {
        flex: 0 0 120px;
        background-color: #cdcdcd;
        border-right: thin solid #000000;
      }
      .employee__labels,
      .employee__values {
        padding: 8px;
      }
      .employee__values {
        flex: 0 0 calc(100% - 120px);
        // .employee__occ {
        //   // white-space: nowrap;
        //   // overflow: hidden;
        //   // text-overflow: ellipsis;
        //   // width: 95%;
        // }
        // .text-wrap-line {
        //   // white-space: pre-wrap;
        // }
      }
    }
    .employee__col-1 {
      margin-right: 4px;
    }
    .employee__col-2 {
      margin-left: 4px;
    }
  }
  &__remu-desc {
    width: 100%;
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;
    align-items: stretch;
  }
  &__remuneracion,
  &__descuentos {
    max-width: 413.11px;
    flex: 1 0 50%;
    display: grid;
    grid-template-columns: 2fr 1fr;
    grid-template-rows: 29px 1fr 29px;
    // flex-flow: column nowrap;
    // justify-content: flex-start;
    // align-content: stretch;
    border: thin solid #000000;
    &-header {
      grid-area: 1 / 1 / 2 / 3;
      display: flex;
      flex-flow: row nowrap;
      justify-content: space-between;
      align-items: center;
      background-color: #cdcdcd;
      border-bottom: thin solid #000000;
      .remuneracion_label,
      .remuneracion_value,
      .descuentos_label,
      .descuentos_value {
        text-align: center;
        padding: 4px;
      }
    }
    &-body {
      grid-area: 2 / 1 / 3 / 3;
      display: flex;
      flex-flow: row nowrap;
      justify-content: space-between;
      align-items: flex-start;
      justify-self: stretch;
      .remuneracion_label,
      .remuneracion_value,
      .descuentos_label,
      .descuentos_value {
        text-align: start;
        padding: 4px;
      }
      .remuneracion_label,
      .descuentos_label {
        width: 70%;
      }
      .remuneracion_value,
      .descuentos_value {
        width: 30%;
        text-align: end;
      }
      .remuneracion_label > div,
      .descuentos_label > div {
        white-space: nowrap;
        width: 100%;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
    &-footer {
      grid-area: 3 / 1 / 4 / 3;
      display: flex;
      flex-flow: row nowrap;
      justify-content: space-between;
      align-items: center;
      margin-top: auto;
      font-weight: bold;
      .remuneracion_label,
      .remuneracion_value,
      .descuentos_label,
      .descuentos_value {
        text-align: center;
        padding: 4px;
        border-top: thin solid #000000;
      }
      .remuneracion_label,
      .descuentos_label {
        width: 70%;
      }
      .remuneracion_value,
      .descuentos_value {
        width: 30%;
        text-align: end;
      }
      .remuneracion_label > div,
      .descuentos_label > div {
        white-space: nowrap;
        width: 100%;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
    .remuneracion_label,
    .descuentos_label {
      flex: 1 0 70%;
      border-right: thin solid #000000;
      height: 100%;
    }
    .remuneracion_value,
    .descuentos_value {
      flex: 1 0 30%;
      height: 100%;
    }
  }
  &__remuneracion {
    margin-right: 4px;
    &-footer {
      background-color: #cdcdcd;
      color: #000;
    }
  }
  &__descuentos {
    margin-left: 4px;
    &-footer {
      background-color: #cdcdcd;
      color: #000;
    }
  }

  &__sueldos-aux {
    margin-top: 1rem;
    width: 100%;
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;
    align-items: stretch;
    .sueldos-aux-basico,
    .sueldos-aux-neto {
      flex: 1 0 50%;
      border: thin solid #000000;
    }
    .sueldos-aux-basico {
      margin-right: 4px;
      display: flex;
      flex-flow: row nowrap;
      justify-content: flex-start;
      align-items: center;
      .sueldo-aux__label {
        flex: 1 0 70%;
        box-sizing: border-box;
        text-align: center;
        height: 100%;
        display: flex;
        flex-flow: row nowrap;
        justify-content: center;
        align-items: center;
        border-right: thin solid #000000;
        background-color: #cdcdcd;
      }
      .sueldo-aux__value {
        flex: 1 0 30%;
        box-sizing: border-box;
        text-align: center;
        height: 100%;
        display: flex;
        flex-flow: row nowrap;
        justify-content: center;
        align-items: center;
      }
    }
    .sueldos-aux-neto {
      margin-left: 4px;
      display: flex;
      flex-flow: row nowrap;
      justify-content: flex-start;
      align-items: center;
      .sueldo-aux__label {
        flex: 1 0 70%;
        box-sizing: border-box;
        text-align: center;
        height: 100%;
        display: flex;
        flex-flow: column nowrap;
        justify-content: center;
        align-items: center;
        div {
          text-align: start;
          width: 100%;
          box-sizing: border-box;
          padding: 4px;
          border-right: thin solid #000000;
        }
        .imp {
          font-weight: bold;
          border: thin solid #000000;
          border-bottom: none;
          border-left: none;
          background-color: #cdcdcd;
        }
      }
      .sueldo-aux__value {
        flex: 1 0 30%;
        box-sizing: border-box;
        text-align: center;
        height: 100%;
        display: flex;
        flex-flow: column nowrap;
        justify-content: center;
        align-items: center;
        div {
          text-align: end;
          width: 100%;
          box-sizing: border-box;
          padding: 4px;
        }
        .imp {
          font-weight: bold;
          border-top: thin solid #000000;
          background-color: #cdcdcd;
        }
      }
    }
  }
  &__extra {
    margin-top: 1rem;
    width: 100%;
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;
    align-items: stretch;
    .extra-info {
      flex: 0 0 50%;
      display: flex;
      flex-flow: column nowrap;
      justify-content: flex-start;
      align-items: stretch;
      &__top {
        margin-bottom: 1rem;
        display: flex;
        flex-flow: row nowrap;
        justify-content: flex-start;
        align-items: stretch;
        .extra-time {
          border: thin solid #000000;
          flex: 0 0 calc(65% - 4px);
          margin-right: 4px;
          display: flex;
          flex-flow: row nowrap;
          justify-content: flex-start;
          align-items: stretch;
          // padding: 4px;
          &__label {
            box-sizing: border-box;
            flex: 0 0 60%;
            text-align: start;
            padding: 4px;
            border-right: thin solid #000000;
          }
          &__value {
            box-sizing: border-box;
            flex: 0 0 40%;
            text-align: end;
            padding: 4px;
          }
        }
        .extra-aporte {
          flex: 0 0 calc(35% - 4px);
          margin-left: 4px;
          border: thin solid #000000;
          &__header {
            text-align: center;
            background-color: #cdcdcd;
            border-bottom: thin solid #000000;
          }
          &__body {
            display: flex;
            flex-flow: row nowrap;
            justify-content: space-between;
            align-items: flex-start;
          }
        }
      }
      &__mid {
        margin-bottom: 1rem;
        display: flex;
        flex-flow: row nowrap;
        justify-content: flex-start;
        align-items: stretch;
        .extra__vacaciones {
          flex: 0 0 calc(65% - 4px);
          margin-right: 4px;
          display: flex;
          flex-flow: column nowrap;
          justify-content: stretch;
          align-items: stretch;
          border: thin solid #000000;
          .vacaciones__header {
            text-align: center;
            border-bottom: thin solid #000000;
            background-color: #cdcdcd;
          }
          .vacaciones__body {
            display: flex;
            flex-flow: row nowrap;
            justify-content: space-between;
            align-items: flex-start;
            .vacaciones__start,
            .vacaciones__end {
              flex: 0 0 50%;
              .start-header,
              .end-header,
              .start-body,
              .end-body {
                text-align: center;
              }
            }
            .vacaciones__start {
              border-right: thin solid #000000;
              .start-header {
                border-bottom: thin solid #000000;
              }
            }
            .vacaciones__end {
              .end-header {
                border-bottom: thin solid #000000;
              }
            }
          }
        }
        .extra__prestamo {
          flex: 0 0 calc(35% - 4px);
          margin-left: 4px;
          display: flex;
          flex-flow: column nowrap;
          justify-content: stretch;
          align-items: stretch;
          border: thin solid #000000;
          .prestamo__header {
            text-align: center;
            border-bottom: thin solid #000000;
            background-color: #cdcdcd;
          }
        }
      }
      &__bot {
        width: 100%;
        display: flex;
        flex-flow: row nowrap;
        border: thin solid #000000;
        justify-content: stretch;
        align-items: flex-start;
        .info-bot__label {
          padding: 4px;
          border-right: thin solid #000000;
        }
        .info-bot__values {
          padding: 4px;
        }
      }
    }
    .extra-sign {
      display: flex;
      flex-flow: column nowrap;
      justify-content: space-around;
      align-items: stretch;
      width: 45%;
      &__empleador,
      &__receptor {
        display: flex;
        flex-flow: column nowrap;
        justify-content: flex-start;
        align-items: center;
        .sign-box {
          height: 80%;
          width: 100%;
          border-bottom: thin dashed #3d3d3d;
        }
        .sign-info {
          height: 20%;
          text-align: center;
        }
      }
    }
  }
  .hide-document {
    // opacity: 0;
    color: #ffffff;
  }
}
.boleta__button-print {
  position: absolute;
  right: 0px;
  top: 0px;
}
.icon-button {
  width: 20px;
}
.toUpperCase {
  text-transform: uppercase;
}
.md-table-head-label {
  height: 35px !important;
}

.z-1000 {
  z-index: 1000;
}
.z-200 {
  z-index: 20;
}
.my-20 {
  margin: 2rem 0;
}
</style>
